import object from 'helpers/object'


export const initialState = {
  isFetching: false,
  cashiers: [],
  access: [],
  schools: [],
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setCashiers = (state, payload) => (
  object.setIn(state, [ 'cashiers' ], payload)
)

export const setAccess = (state, payload) => (
  object.setIn(state, [ 'access' ], payload)
)

export const setSchools = (state, payload) => (
  object.setIn(state, [ 'schools' ], payload)
)
